import React, { useState } from 'react';
import { updateTransaction } from '../services/transactionService';

// Per-deal "Automated emails" switch. On unless someone turned it off (missing field = on).
// When off, no automatic email goes out for this deal (checked in the app and again on the server).
export default function AutomatedEmailsToggle({ transaction, transactionId, ownerUid, onChange }) {
  const on = transaction?.automatedEmailsEnabled !== false;
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  // Client emails need approval unless this deal is set to auto-send (missing field = approval required).
  const [mode, setMode] = useState(transaction?.emailApproval === 'auto' ? 'auto' : 'required');
  const setApproval = async (next) => {
    if (next === 'auto' && !window.confirm('Auto-send client emails on this deal without approval?')) return;
    setBusy(true); setErr('');
    try { await updateTransaction(ownerUid, transactionId, { emailApproval: next }); setMode(next); } catch (e) { setErr('Could not save. Try again.'); } finally { setBusy(false); }
  };
  const flip = async () => {
    const next = !on;
    if (!next && !window.confirm('Turn OFF automated emails for this deal? No automatic emails will go out for it until you turn them back on.')) return;
    setBusy(true); setErr('');
    try {
      await updateTransaction(ownerUid, transactionId, { automatedEmailsEnabled: next });
      onChange && onChange(next);
    } catch (e) { setErr('Could not save. Try again.'); } finally { setBusy(false); }
  };
  return (
    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 12, padding: '12px 16px', margin: '0 0 16px', borderRadius: 10, border: `2px solid ${on ? '#B8962E' : '#C0392B'}`, background: on ? '#FBF7EC' : '#FDF0EE' }}>
      <div style={{ flex: '1 1 220px' }}>
        <div style={{ fontWeight: 700, fontSize: 15, color: '#1A1A1A' }}>Automated emails: {on ? 'ON' : 'OFF'}</div>
        <div style={{ fontSize: 13, color: '#5B6270' }}>{on ? 'Automatic emails for this deal send on their scheduled dates.' : 'No automatic emails will go out for this deal.'}</div>
        {on && <div style={{ fontSize: 13, marginTop: 6 }}>
          Client emails: <strong>Approval required</strong> (each one becomes an Approve email task).
          <div style={{ fontSize: 12, color: '#5B6270' }}>Auto-send to clients is turned off team-wide for now. Team (internal) emails still send automatically.</div>
        </div>}
        {err && <div style={{ fontSize: 13, color: '#C0392B' }}>{err}</div>}
      </div>
      <button type="button" role="switch" aria-checked={on} disabled={busy} onClick={flip}
        style={{ padding: '8px 16px', borderRadius: 20, fontWeight: 700, cursor: busy ? 'wait' : 'pointer', border: '1px solid #1A1A1A', background: on ? '#1A1A1A' : '#FFFFFF', color: on ? '#D4AF37' : '#1A1A1A' }}>
        {busy ? 'Saving...' : on ? 'Turn off' : 'Turn on'}
      </button>
    </div>
  );
}
